












































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'SecondaryWalletsGeneralSettingsEditDialog' })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    get product() {
        return ProductDetailsModule.product;
    }

    get productVM() {
        return ProductDetailsModule.productVM;
    }

    async save() {
        this.dialog = false;
        await ProductDetailsModule.editSecondaryWalletSettings();
    }

}
